/**
 * @file PaddleHub banner文字卡片
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {FC} from 'react';

import {IBannerTextCardItem} from './types';
import A from '../../../../components/a/A';

const BannerTextCard: FC<IBannerTextCardItem> = (props) => {
    const {
        title,
        content,
        link
    } = props;

    return (
        <A href={link} className="paddle-banner-text-card">
            <div className="paddle-banner-text-card-icon" />
            <div className="paddle-banner-text-card-info">
                <div className="paddle-banner-text-card-title">{title}</div>
                <div className="paddle-banner-text-card-text">{content}</div>
            </div>
        </A>
    );
};

export default BannerTextCard;
